<template>
    <div>
        <div class="remark">
            <a href="https://gczjedu.yndkkj.com/prod-api/profile/site/train_notice.png" target="_blank" class="link">宣贯培训须知</a>
        </div>
        <div class="text">
            欢迎参加《云南省建设工程造价计价标准（2020版）》宣贯学习 <br />
            <div class="title">1、个人报名流程</div>
            点击账号注册 → 选择个人注册 → 完成注册后即已提交报名信息 → 进入后，选择菜单栏“宣贯学习→学习列表”，根据提示完成相应流程 →
            个人报名成功。个人报名学员用身份证号码及自己设置的密码登录学习。
            注：已注册二级造价师管理的学员可直接用原账号密码登录报名、学习；如忘记密码，请找回密码登录。
            <br />
            <div class="title">2、企业批量报名流程</div>
            点击账号注册 → 选择企业注册 → 提交企业基本信息并添加学员信息 → 提交报名 →根据提示完成相应流程→ 企业批量报名成功 →
            企业批量报名的个人学员直接用身份证号和身份证后八位密码登录学习。<br />
            <div class="title">3、打印学习证明</div>
            学习完成，学员可登录宣贯学习，选择菜单栏“宣贯学习→学习列表”，即可打印学习证明。<br />
            <div class="title">4、咨询电话</div>
            报名咨询电话： 0871-68184040、0871-68180804 学习、开票咨询电话：0871-63122229。
        </div>
    </div>
</template>
<script>
export default {
    name: 'notice',
    methods: {
        //关闭弹窗
        handleClose() {
            this.dialogVisible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.remark {
    display: flex;
    justify-content: center;
    .link {
        font-size: 14px;
        color: #1492e6;
        text-decoration: underline;
        transition: all 0.2s;
        &:hover {
            color: #33b3f3;
        }
    }
}
.text {
    margin-top: 30px;
    color: #333;
    font-size: 14px;
    line-height: 24px;
    .title {
        font-weight: bold;
    }
}
</style>
